import script from "./Application.vue?vue&type=script&lang=ts&setup=true"
export * from "./Application.vue?vue&type=script&lang=ts&setup=true"

import "@klausapp/ui-kit/styles/tailwind.css?vue&type=style&index=0&lang=css&external"
import "@klausapp/ui-kit/styles/variables.css?vue&type=style&index=1&lang=css&external"
import "@klausapp/ui-kit/styles/global.css?vue&type=style&index=2&lang=css&external"
import "@/styles/settings.scss?vue&type=style&index=3&lang=scss&external"
import "@/styles/sweetalert2.scss?vue&type=style&index=4&lang=scss&external"
import "@/styles/tippy.scss?vue&type=style&index=5&lang=scss&external"
import "./Application.vue?vue&type=style&index=6&id=293d4e40&lang=scss"
const cssModules = {}
import style7 from "./Application.vue?vue&type=style&index=7&id=293d4e40&module=true&lang=css"
cssModules["$style"] = style7

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__